<template>
  <aside class="app-sidebar" aria-label="Hauptnavigation">
    <router-link class="brand px-2" to="/">
      <BrandMark />
      <span>SSU Admin</span>
    </router-link>

    <nav class="d-flex flex-column gap-3">
      <div v-for="group in groups" :key="group.title" class="d-flex flex-column gap-1">
        <span v-if="group.title" class="nav-group-label">{{ group.title }}</span>
        <router-link v-for="item in group.entries" :key="item.name" class="side-link" :class="{ active: isActive(item) }" :to="item.to">
          <font-awesome-icon class="side-link-icon" :icon="item.icon" />
          <span>{{ item.title }}</span>
        </router-link>
      </div>
    </nav>
  </aside>
</template>

<script setup>
import BrandMark from "@/components/frame/BrandMark.vue";
import { useNavigation } from "@/composables/useNavigation";

defineOptions({ name: "MainSidebar" });

const { groups, isActive } = useNavigation();
</script>
